import React, { Component } from 'react';
import styled from 'styled-components';

import { MdHelp as Help } from 'react-icons/md';
import { MdMenu as MenuIcon } from 'react-icons/md';
import MediaQuery from 'react-responsive';

import { connect } from 'react-redux';

import ChatIcon from './ChatIcon.js';
import SettingsPopover from './SettingsPopover';
import './NavBar.css';

import { isOnlyApiUser, isSelfService } from 'helpers/Authentication';
import LandlordLogo from 'components/shared/LandlordLogo';
import SelectWithButton from 'components/ui/SelectWithButton';
import { RenderIfToggleOn } from 'components/shared/ToggleRenderer';

import { setGlobalFilter } from 'actions/userTypesActions';

import Button from '@material-ui/core/Button';
import { getCurrentLocale, getTranslatedString } from 'helpers/i18n';
import { colors } from 'helpers/ColorHelper';
import { localizeHelpLink } from 'helpers/Localization';
import { media } from 'helpers/MediaHelper';

const GlobalFilterContainer = styled.div`
  padding: 8px;
  display: table-cell;
  padding-right: 30px;
  ${media.mobile`
    display: none;
  `};
`;

let NavBar = connect(
  (store) => ({
    permissions: store.userTypes.permissions,
    userType: store.userTypes.userType,
    showMessaging: store.userTypes.showMessaging,
    userPermissions: store.userTypes.permissions,
    showHelp: store.userTypes.showHelp,
    globalFilter: store.userTypes.globalFilter,
    portfolios: store.landlordProperties.portfolios,
  }),
  { setGlobalFilter }
)(
  class NavBar extends Component {
    handleChange(e) {
      if (this.props.sidebarIsOpen) {
        this.props.dockSidebar(false, false);
      } else if (!this.props.sidebarIsOpen) {
        this.props.dockSidebar(true, true);
      }
    }

    handleGlobalFilterChange = (portfolioId) => {
      this.props.setGlobalFilter(portfolioId);
    };

    render() {
      const style = {
        menu_icon: {
          fontSize: '30px',
          marginRight: '15px',
        },
        button: { padding: '8px', minWidth: '40px', color: colors.MENU_ITEM_GRAY },
      };

      const { helpDocuments } = this.props;
      const language = getCurrentLocale();

      const portfolios = [
        {
          label: getTranslatedString('landlordPortal.navbar.globalFilter.allPortfolios'),
          value: 'all',
        },
        ...this.props.portfolios,
      ];

      return (
        <div className="flex-fixed nav-bar" style={{ position: 'absolute', width: '100%' }}>
          <header className="global-header-view">
            <nav>
              <div className="navigation-canvas">
                <div>
                  <div className="global-header-left">
                    <div>
                      <div className="global-header-item-container">
                        <span className="global-header-left global-header-item">
                          {this.props.showSideBar && (
                            <MediaQuery query="(min-device-width: 750px)">
                              <button
                                className="global-header-item-button collapse-trigger"
                                onClick={this.handleChange.bind(this)}
                              >
                                <MenuIcon style={style.menu_icon} />
                              </button>
                            </MediaQuery>
                          )}
                          {!this.props.showSideBar && (
                            <MediaQuery query="(min-device-width: 750px)">
                              <div className="mobile-app-logo" style={{ fontSize: '24px' }}>
                                <LandlordLogo maxWidth="137px" height="46px" textHeight="27px" />
                              </div>
                            </MediaQuery>
                          )}
                          <MediaQuery query="(max-device-width: 750px)">
                            <div
                              className="mobile-app-logo"
                              style={{
                                width: '116px',
                                float: 'left',
                                marginTop: '-4px',
                                marginLeft: '16px',
                              }}
                            >
                              <LandlordLogo
                                maxWidth="116px"
                                height="46px"
                                textHeight="27px"
                                textAlign="left"
                              />
                            </div>
                          </MediaQuery>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="global-header-right">
                    <div>
                      <div className="global-header-item-container alert">
                        <RenderIfToggleOn
                          toggle="agents.global_filter"
                          dontRenderIf={this.props.portfolios.length === 0}
                        >
                          <div className="global-header-item">
                            <GlobalFilterContainer>
                              <SelectWithButton
                                options={portfolios}
                                placeholder={getTranslatedString(
                                  'landlordPortal.navbar.globalFilter.allPortfolios'
                                )}
                                buttonCta={getTranslatedString(
                                  'landlordPortal.navbar.globalFilter.buttonCta'
                                )}
                                value={this.props.globalFilter}
                                handleChange={this.handleGlobalFilterChange}
                              />
                            </GlobalFilterContainer>
                          </div>
                        </RenderIfToggleOn>
                        {!isOnlyApiUser(this.props.permissions) &&
                          !isSelfService(this.props.permissions) &&
                          this.props.showMessaging &&
                          this.props.userPermissions.messaging &&
                          this.props.userType !== 'maintenance' && (
                            <span className="global-header-item">
                              <ChatIcon className="global-header-item-button" />
                            </span>
                          )}
                        <span className="global-header-item settings" id={'settings-dropdown'}>
                          <SettingsPopover
                            logUserOut={this.props.logUserOut}
                            userType={this.props.userType}
                          />
                          <div className="flyout-tip" />
                        </span>
                        {!isSelfService(this.props.permissions) && this.props.showHelp && (
                          <span className="global-header-item help">
                            <a
                              href={localizeHelpLink(helpDocuments, language, 'landlordPortal')}
                              target="_blank"
                              rel="noopener noreferrer"
                              aria-label="help"
                            >
                              <Button aria-label="help" style={style.button}>
                                <Help size={25} style={{ color: colors.BLUE }} />
                              </Button>
                            </a>
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </nav>
          </header>
        </div>
      );
    }
  }
);

export default NavBar;
